window.ShopgateCliplister = function(options) {
	var that = this,
		defaults = {
			getCodeUrl: null,
			targetElementSelector: '.js-cliplister-placeholder'
		},
		$elements = {},
		cliplisterCode = null;


	that.update = function(productData) {
		$elements.videoPanel.empty();
		cliplisterCode = null;
		$.ajax({
			url: options.getCodeUrl + '/' + productData.id,
			success: _onSuccess,
			error: _onError
		});
		
		function _onSuccess(response) {
			if (typeof response !== 'undefined' && response.success && response.html) {
				cliplisterCode = JSON.parse(response.html);
				var config = {
					elementID: $elements.videoPanel.attr('id'),
					slot: parseInt(cliplisterCode.slot),
					keytype: parseInt(cliplisterCode.keytype),
					indirect: false,
					autoplay: false,
					size: cliplisterCode.width + 'x' + cliplisterCode.height,
					lang: cliplisterCode.lang,
					onReady: function() {
						$elements.videoPanel
								.find('div')
									.css({
										'margin-left': 'auto',
										'margin-right': 'auto'
									});

					}
				};
				if (cliplisterCode.productKey !== null) {
					config['requestkey'] = cliplisterCode.productKey;
				} else {
					if (Number.parseInt(cliplisterCode.keytype) === 0) {
						config['requestkey'] = productData.ean;
					} else {
						config['requestkey'] = productData.product_number;
					}
				}

				Cliplister.player(config, cliplisterCode.customerId);

				/*
				 * trigger custom event so that the cliplister lib can start it's work
				 * --> for more information see cliplister-content_integration_lib.js
				 */
				var cliplisterEvent = new CustomEvent('cliplister_load_config_finished_event');
				document.dispatchEvent(cliplisterEvent);
			}
		}
		
		function _onError() {
			console.warn('Cliplister failed on downloading it\'s code.');
		}
		
	};

	function _init() {
		try {
			_sanitizeOptions();
			_validateOptions();
			_prepareElements();

		} catch (e) {
			// if something is wrong we don't throw error since
			// it can make all the app down, it's better to put
			// this code to sleep gracefully
			console.warn('Invalid options provided for ShopgateCliplister. Cliplister will not be shown. Cause: ' + e.message);

			return false;
		}

		return true;

	}

	function _sanitizeOptions() {
		options = $.extend({}, defaults, options);

	}

	function _prepareElements() {
		$elements.videoPanel = _getVideoWrapper();
		$elements.targetElement = $(options.targetElementSelector);

		if ($elements.targetElement.length === 0) {
			throw new Error('Target element not found.');
		}

		$elements.targetElement.prepend($elements.videoPanel);
	}
	
	function _getVideoWrapper() {
		var $wrapperElement = $('<div class="row cliplister-video text-center" id="cliplisterVideoBody">');

		return $wrapperElement;

	}

	function _validateOptions() {
		if (!options.getCodeUrl) {
			throw new Error('getCodeUrl not provided.');
		}
	}

	_init();

	return that;
};



// WEBPACK FOOTER //
// ./Library/1.0/common/product_details/shopgate-cliplister.js